var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 39.75,
    r: 39.75,
    fill: "#EBF3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9946 15.8955L74.4254 69.0126C75.7979 71.4897 74.8993 74.6087 72.4182 75.979C71.6575 76.3992 70.8024 76.6196 69.933 76.6196H11.0715C8.23605 76.6196 5.9375 74.3247 5.9375 71.4938C5.9375 70.6258 6.15826 69.7721 6.57907 69.0126L36.0099 15.8955C37.3824 13.4184 40.5063 12.5212 42.9874 13.8915C43.8318 14.3579 44.5275 15.0524 44.9946 15.8955ZM39.0625 36.2935C38.2671 36.2935 37.6223 36.9383 37.6223 37.7337V55.0163C37.6223 55.8117 38.2671 56.4565 39.0625 56.4565H41.9429C42.7383 56.4565 43.3832 55.8117 43.3832 55.0163V37.7337C43.3832 36.9383 42.7383 36.2935 41.9429 36.2935H39.0625ZM39.0625 62.2174C38.2671 62.2174 37.6223 62.8622 37.6223 63.6576V66.538C37.6223 67.3335 38.2671 67.9783 39.0625 67.9783H41.9429C42.7383 67.9783 43.3832 67.3335 43.3832 66.538V63.6576C43.3832 62.8622 42.7383 62.2174 41.9429 62.2174H39.0625Z",
    fill: "#9E007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.a03fd0f2828700fdba3280d59b5a4029.svg";
export { ForwardRef as ReactComponent };